module.exports = __webpack_public_path__ + "img/logo_easy.96d8f230.png";